import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BfxBlotterOrdersContextMenuItemAcceptanceState } from "shared/cubiq-services";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";

export class BfxPopupAcceptanceCancelNotificationData extends BfxPopupNotificationData {
  public acceptanceState: BfxBlotterOrdersContextMenuItemAcceptanceState;

  /**
   * Flag used to determine the action and action types available
   */
  private _bmarkOrder: boolean = false;

  constructor(
    type: BFXNotificationType,
    private activeUser: CubiqServices.ActiveUser,
    private hasAccept: boolean,
    private hasReject: boolean,
    private hasUnrestricted: boolean,
  ) {
    super(type, "icon-bfx_cancel", BFXNotificationSubType.ACCEPTANCE_CANCEL);
    this.acceptanceState = new BfxBlotterOrdersContextMenuItemAcceptanceState();
    this.acceptanceState.actionRequests = {
      accept: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      acceptInto: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      reject: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
    };
  }

  reInitMaps() {
    this.acceptanceState.actionRequests.accept.acceptance.clear();
    this.acceptanceState.actionRequests.accept.xfer.clear();
    this.acceptanceState.actionRequests.acceptInto.acceptance.clear();
    this.acceptanceState.actionRequests.acceptInto.xfer.clear();
    this.acceptanceState.actionRequests.reject.acceptance.clear();
    this.acceptanceState.actionRequests.reject.xfer.clear();
  }

  private addToAcceptMap(orderId: string) {
    if (!this.acceptanceState.actionRequests.accept.acceptance.has(CubiqTS.AcceptanceType.CANCEL)) {
      this.acceptanceState.actionRequests.accept.acceptance.set(CubiqTS.AcceptanceType.CANCEL, []);
    }
    this.acceptanceState.actionRequests.accept.acceptance
      .get(CubiqTS.AcceptanceType.CANCEL)
      .push(orderId);
  }
  private addToRejectMap(orderId: string) {
    if (!this.acceptanceState.actionRequests.reject.acceptance.has(CubiqTS.AcceptanceType.CANCEL)) {
      this.acceptanceState.actionRequests.reject.acceptance.set(CubiqTS.AcceptanceType.CANCEL, []);
    }
    this.acceptanceState.actionRequests.reject.acceptance
      .get(CubiqTS.AcceptanceType.CANCEL)
      .push(orderId);
  }

  protected override updateAllowableActions() {
    this.actions = [];
    this.reInitMaps();
    if (
      this.hasUnrestricted ||
      (this.activeUser.userTypeId === CubiqTS.UserType.TRADER && (this.hasAccept || this.hasReject))
    ) {
      let acceptCount: number = 0;
      let rejectCount: number = 0;

      this.payload.forEach((item) => {
        if (
          this.hasUnrestricted ||
          ((this.hasAccept || this.hasReject) &&
            (item.as_fv_deskId === "-1" ||
              this.activeUser.tradingGroupsIds.indexOf(item.as_fv_deskId) > -1))
        ) {
          if (this.hasUnrestricted || this.hasAccept) {
            acceptCount++;
            this.addToAcceptMap(item.orderId);
          }
          if (this.hasUnrestricted || this.hasReject) {
            rejectCount++;
            this.addToRejectMap(item.orderId);
          }
        }
      });

      if (acceptCount == this.payload.length) {
        const commandId = this._bmarkOrder
          ? BfxPopupNotificationCommand.POPUP_INTERVENTION_TRADER_ACCEPT
          : BfxPopupNotificationCommand.POPUP_DI_ACCEPT;
        this.actions.push({
          label: "Accept",
          command: commandId,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (rejectCount == this.payload.length) {
        const commandId = this._bmarkOrder
          ? BfxPopupNotificationCommand.POPUP_INTERVENTION_TRADER_REJECT
          : BfxPopupNotificationCommand.POPUP_DI_REJECT;
        this.actions.push({
          label: "Reject",
          command: commandId,
          icon: "fa icon-menu-error bfx-context-menu-icon",
          styleClass: "bfx-context-menu-item-enabled",
          separatorBefore: this.actions.length > 0,
        });
      }
    }
  }

  destroy() {
    super.destroy();
    this.activeUser = null;
  }

  /**
   * Update bmarkOrder flag and ensure the typeStr of the data is keyed off the
   * bmarkOrder flag
   */
  public set isBmarkOrder(value: boolean) {
    if (value != this._bmarkOrder) {
      this._bmarkOrder = value;
      if (value) {
        // Ensure that bmark and non-bmark acceptance notification do not get merged
        if (!this.typeStr.endsWith("_BMARK")) {
          this.typeStr = this.typeStr + "_BMARK";
        }
      } else {
        if (this.typeStr.endsWith("_BMARK")) {
          // Remove the prefix
          this.typeStr = this.typeStr.substring(0, this.typeStr.length - 6);
        }
      }
      this.updateAllowableActions();
    }
  }
}
